module.exports = __webpack_public_path__ + "static/media/avatar-man.c9ac9c1a.png";